/*
  The highlight statement, inked in word by word as the page scrolls.

  The words are never hidden. They start as a faint draft of themselves and
  darken, left to right, as the statement comes up the screen, so a visitor
  arriving at the section always finds the sentence already there — a blank
  stretch of beige at this point would read as the end of the page.

  Nothing is held or pinned: the effect runs on the visitor's own scroll, at
  their pace, and runs back if they scroll back. It is finished before the
  statement reaches the middle of the screen, so nobody is left waiting for
  it.

  Each word's strength is written as opacity rather than a colour, so the ink
  keeps following the drop colour when the wash rolls through this section.

  With no JavaScript, or with reduced motion, the statement is simply there
  in full.
*/
(function () {
  /* How faint a word is before its turn. Faint, but never so faint that the
     statement reads as a blank stretch of beige before it starts — which at
     this point in the page would read as the end of it. */
  var DRAFT = 0.2;
  /* Where the statement is when the first word starts: its top edge this far
     down the screen. It begins as the first line clears the bottom, so the
     inking has the whole of the statement's climb to happen in. */
  var START = 1;
  /*
    Where it is when the last word lands: its middle this far down the screen.
    Above centre rather than below it, so the ink has the statement's whole
    climb to travel across and is watched arriving rather than found already
    arrived.

    It cannot go much higher. The statement's own space was measured so the
    inking finishes before the drop colour starts washing over the page below,
    and the two crossing means one runs under the other. That crossing point is
    0.35 on the shortest screen this is drawn for, so this keeps a tenth of a
    screen in hand.
  */
  var END = 0.45;
  /* How many words darken at once. More is softer: the ink runs along the
     line instead of stepping from word to word. Under two, each word is most
     of the way in before the next one starts, which is what makes the ink
     read as travelling rather than as the whole line fading up. */
  var SPREAD = 1.5;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(n) {
    return n < 0 ? 0 : n > 1 ? 1 : n;
  }

  /* Wraps every word of the statement in its own span, leaving the spaces and
     any bold or italic set in the admin exactly where they were. */
  function split(root) {
    var words = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      if (parts.length === 1 && !parts[0].trim()) return;

      var fragment = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (!part.trim()) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }
        var span = document.createElement('span');
        span.className = 'highlight__word';
        span.textContent = part;
        fragment.appendChild(span);
        words.push(span);
      });
      node.parentNode.replaceChild(fragment, node);
    });

    return words;
  }

  function init(section) {
    if (section.dataset.hlReady === 'true') return;
    var text = section.querySelector('[data-hl-text]');
    if (!text) return;
    section.dataset.hlReady = 'true';

    var words = split(text);
    if (!words.length) return;

    var last = [];

    function paint(amount) {
      var total = words.length + SPREAD;
      for (var i = 0; i < words.length; i++) {
        var own = clamp((amount * total - i) / SPREAD);
        var value = reduced.matches ? 1 : DRAFT + (1 - DRAFT) * own;
        /* Written only when it changes, so a still page costs nothing. */
        var rounded = Math.round(value * 100) / 100;
        if (last[i] !== rounded) {
          words[i].style.opacity = rounded;
          last[i] = rounded;
        }
      }
    }

    function update() {
      if (reduced.matches) {
        paint(1);
        return;
      }
      var box = text.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var from = vh * START;
      var to = vh * END - box.height / 2;
      paint(clamp((from - box.top) / (from - to)));
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    /* Only listens while the statement is anywhere near the screen. */
    var watching = false;
    function watch(on) {
      if (on === watching) return;
      watching = on;
      if (on) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      } else {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        /* Left where the visitor's scroll put it on the way out: fully inked
           below, back to draft above. */
        update();
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          watch(entries[0].isIntersecting);
        },
        { rootMargin: '25% 0px' }
      ).observe(section);
    } else {
      watch(true);
    }

    if (reduced.addEventListener) reduced.addEventListener('change', update);
    update();
  }

  function start() {
    var sections = document.querySelectorAll('[data-highlight-reveal]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
